import { useState } from 'react'

import { Modal } from '@/components/common/Modal'
import { InterviewDetailsView, InterviewForm } from '@/components/forms'
import { useDisclosure } from '@/components/nextui'
import { useAuthStore } from '@/store/authStore'
import { FormsProps } from '@/types/forms/formStatus'

export const InterviewModule = ({
    onNext,
    onPrevious,
    idLastForm,
    completed,
    hasNextStep
}: FormsProps): JSX.Element => {
    const [page, setPage] = useState<number>(idLastForm)
    const { inscriptionStatusId } = useAuthStore()
    const { isOpen, onClose, onOpen } = useDisclosure()

    // Verificar si el aspirante está admitido/matriculado (inscriptionStatusId === 3, 4 o 6)
    const isBlocked =
        inscriptionStatusId === 3 ||
        inscriptionStatusId === 4 ||
        inscriptionStatusId === 6

    const handleBlockedClick = () => {
        if (isBlocked) {
            onOpen()
        }
    }

    const onNextPage = (): void => {
        onNext()
    }

    const renderPage = (): JSX.Element | undefined => {
        switch (page) {
            case 1:
                return (
                    <InterviewForm
                        onNext={onNextPage}
                        onPrevious={onPrevious}
                        hasNextStep={hasNextStep}
                    />
                )
            case 2:
                return (
                    <InterviewDetailsView
                        onNext={onNextPage}
                        onPrevious={onPrevious}
                    />
                )

            default:
                break
        }
    }

    return (
        <div className={`relative ${isBlocked ? 'opacity-60' : ''}`}>
            {isBlocked && (
                <>
                    <div className="absolute inset-0 z-10 bg-gray-200 bg-opacity-50 cursor-not-allowed" />
                    <div
                        className="absolute inset-0 z-20 bg-transparent cursor-pointer"
                        onClick={handleBlockedClick}
                    />
                    <div className="absolute top-2 right-2 z-30 bg-yellow-100 border border-yellow-400 text-yellow-800 px-2 py-1 rounded text-xs">
                        🔒 Campos bloqueados - Click para más información
                    </div>
                </>
            )}
            <Modal
                isOpen={isOpen}
                onClose={onClose}
                text="inscriptionDataChange"
            />
            <section>{renderPage()}</section>
        </div>
    )
}
